/* unplugin-vue-components disabled */import { render } from "./CommunityIndex.vue?vue&type=template&id=28f51750"
import script from "./CommunityIndex.vue?vue&type=script&lang=js"
export * from "./CommunityIndex.vue?vue&type=script&lang=js"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__